// src/app/core/auth/access-api.service.ts
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ApiResponse<T = unknown> {
  status: 'Ok' | 'Error';
  msg: string | null;
  url: string | null;
  data: T;
  records?: unknown[];
  count?: number;
}

export interface LoginData {
  sessionRestarted?: boolean;
  requiresPasswordChange?: boolean;
  token: string;
}

@Injectable({ providedIn: 'root' })
export class AccessApiService {
  private readonly http = inject(HttpClient);

  login(username: string, password: string): Observable<ApiResponse<LoginData>> {
    return this.http.post<ApiResponse<LoginData>>(
      `${environment.apiUrl}/api/access/login`,
      { UserName: username, Password: password }
    );
  }

  logout(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${environment.apiUrl}/api/access/logout`, {});
  }

  changePasswordAtLogin(password: string, repeatPassword: string): Observable<ApiResponse<LoginData>> {
    return this.http.post<ApiResponse<LoginData>>(
      `${environment.apiUrl}/api/access/change-password-at-login`,
      { Password: password, RepeatPassword: repeatPassword }
    );
  }

  resetPassword(username: string): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(
      `${environment.apiUrl}/api/access/reset-password`,
      { UserName: username }
    );
  }
}
